import { render, staticRenderFns } from "./GuestLeaveApproval.vue?vue&type=template&id=4ffc015a&"
import script from "./GuestLeaveApproval.vue?vue&type=script&lang=js&"
export * from "./GuestLeaveApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GuestLeaveApproval.vue"
export default component.exports